import {useLayoutEffect, useRef} from "react";

import {URL_ORIGINAL_WEBSITE} from "@/lib/links";

import marketingFooterHtml from "./marketingFooter.html?raw";

import "./marketingFooter.scss";

const MarketingFooter = () => {
  const htmlRef = useRef<HTMLDivElement>(null);

  useLayoutEffect(() => {
    const timeout = setTimeout(() => {
      if (!htmlRef.current) return;

      // Transform relative paths into absolute paths leading to the original website
      const updatedHtml = marketingFooterHtml.replace(/href="\/(?!\/)/g, `href="${URL_ORIGINAL_WEBSITE}/`);

      const range = document.createRange();
      range.selectNode(htmlRef.current);
      const documentFragment = range.createContextualFragment(updatedHtml);

      htmlRef.current.innerHTML = "";
      htmlRef.current.append(documentFragment);

      // This is needed to ensure that any scripts in the header HTML
      // are executed for the accordion in the mobile footer
      document.dispatchEvent(new Event("DOMContentLoaded"));
    }, 0);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  return <div className="marketingFooterWrapper" ref={htmlRef} />;
};

export default MarketingFooter;
